import React from 'react';
import { motion } from 'framer-motion';
import { Tag, Zap } from 'lucide-react';
export function MarqueeBanner() {
  return <motion.div initial={{
    y: -80,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    type: 'spring',
    damping: 20,
    stiffness: 180,
    delay: 0.3
  }} className="w-full z-50 relative" style={{
    background: 'linear-gradient(135deg, #1a0000 0%, #2d0000 50%, #1a0000 100%)',
    borderBottom: '2px solid #ff1a1a',
    boxShadow: '0 0 24px rgba(255,26,26,0.5), 0 4px 20px rgba(255,26,26,0.2)'
  }} data-id="element-114">
      {/* Top accent line */}
      <div className="w-full h-[2px]" style={{
      background: 'linear-gradient(90deg, transparent, #ff1a1a, #ff4444, #ff1a1a, transparent)'
    }} data-id="element-115" />

      <div className="w-full px-4 py-3 flex items-center gap-4" data-id="element-116">
        {/* Icon */}
        <motion.div animate={{
        scale: [1, 1.2, 1]
      }} transition={{
        duration: 1.2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="shrink-0" style={{
        filter: 'drop-shadow(0 0 8px rgba(255,26,26,0.9))'
      }} data-id="element-117">
          <Zap className="w-5 h-5 md:w-6 md:h-6" style={{
          color: '#ff4444'
        }} data-id="element-118" />
        </motion.div>

        {/* Text content */}
        <div className="flex-1 flex flex-col sm:flex-row sm:items-center sm:justify-center gap-1 sm:gap-3 min-w-0" data-id="element-119">
          {/* Badge */}
          <span className="shrink-0 font-black uppercase tracking-widest px-2 py-0.5 rounded border self-start sm:self-auto text-[14px] text-[#00FF40]" style={{
          borderColor: '#ff1a1a',
          background: 'rgba(255,26,26,0.15)',
          textShadow: '0 0 8px rgba(255,26,26,0.8)'
        }} data-id="element-120">
            ⚡ OFERTA EXCLUSIVA · 48HRS
          </span>

          {/* Main offer text */}
          <p className="font-black text-sm md:text-base uppercase tracking-wide leading-tight" style={{
          color: '#ffffff',
          textShadow: '0 0 12px rgba(255,26,26,0.6)'
        }} data-id="element-121">
            Kit Esencial{' '}
            <span className="font-black text-[#00FF40]" style={{
            textShadow: '0 0 16px rgba(255,68,68,1)'
          }} data-id="element-122">
              $8.89
            </span>{' '}
            · Kit Completo{' '}
            <span className="font-black text-[#00FF40]" style={{
            textShadow: '0 0 16px rgba(255,68,68,1)'
          }} data-id="element-123">
              $14.89
            </span>
          </p>

          {/* CTA text */}
          <motion.span animate={{
          opacity: [0.7, 1, 0.7],
          textShadow: ['0 0 6px rgba(255,26,26,0.4)', '0 0 18px rgba(255,26,26,0.9)', '0 0 6px rgba(255,26,26,0.4)']
        }} transition={{
          duration: 1.5,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="shrink-0 md:text-sm font-bold uppercase tracking-widest text-[16px] text-[#FFFFFF]" data-id="element-124">
            ¡APROVECHA AHORA!
          </motion.span>
        </div>

        {/* Right icon */}
        <motion.div animate={{
        scale: [1, 1.2, 1]
      }} transition={{
        duration: 1.2,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 0.6
      }} className="shrink-0" style={{
        filter: 'drop-shadow(0 0 8px rgba(255,26,26,0.9))'
      }} data-id="element-125">
          <Zap className="w-5 h-5 md:w-6 md:h-6" style={{
          color: '#ff4444'
        }} data-id="element-126" />
        </motion.div>
      </div>

      {/* Bottom accent line */}
      <div className="w-full h-[1px]" style={{
      background: 'linear-gradient(90deg, transparent, #ff1a1a44, #ff1a1a, #ff1a1a44, transparent)'
    }} data-id="element-127" />
    </motion.div>;
}